import _ from 'lodash'
import CONSTANTS from '@src/constants'
import changelog from '../../assets/changelog'
import changelogEN from '../../assets/changelog-en'

export const state = {
  dev: false,
  experimental: false,
  breakpoint: {},
  theme: 'light',
  language: 'de',
  dense: false,
  changelogs: [],
  messages: [],
  tour: [],
  tableConfig: {...CONSTANTS.DEFAULT_TABLE_CONFIG},
  visibility: false,
  formatter: {...CONSTANTS.DATE_FORMATTER.iso}
}

export const mutations = {
  SET_DEV_MODE(state, mode) {
    state.dev = mode
  },
  SET_EXPERIMENTAL_MODE(state, mode) {
    state.experimental = mode
  },
  SET_BREAKPOINT(state, breakpoint) {
    state.breakpoint = _.omit({...breakpoint}, ['framework', 'thresholds'])
  },
  SET_APP_THEME(state, newTheme) {
    state.theme = newTheme
  },
  SET_APP_LANGUAGE(state, language) {
    state.language = language
  },
  SET_APP_DENSE(state, dense) {
    state.dense = dense
  },
  SET_APP_FORMATTER(state, formatter) {
    state.formatter = formatter
  },
  SET_CHANGE_LOG(state, logs) {
    state.changelogs = logs
  },
  SET_TOUR_STEPS(state, tour) {
    state.tour = tour
  },
  SET_MESSAGES(state, messages) {
    state.messages = messages
  },
  ADD_MESSAGE(state, message) {
    // prevent duplicates
    const exists = _.find(state.messages, {id: message.id})
    if (!exists) state.messages.push(message)
  },

  SET_VISIBILITY(state, hidden) {
    state.visibility = hidden
  }
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ dispatch, commit }) {
    const isDev = process.env.NODE_ENV === 'development' || process.env.VUE_APP_DEV === 'true'
    commit('SET_DEV_MODE', isDev)
    commit('SET_EXPERIMENTAL_MODE', process.env.VUE_APP_EXPERIMENTAL === 'true')
    dispatch('changelogs')
  },
  breakpoint({ dispatch, commit }, breakpoint) {
    commit('SET_BREAKPOINT', breakpoint)
    // dispatch('SET_APP_FORMATTER', CONSTANTS.DATE_FORMATTER.short)
  },
  language({ dispatch, commit }, language) {
    commit('SET_APP_LANGUAGE', language)
    dispatch('changelogs')
  },
  formatter({ commit }, formattype) {
    const formatter = CONSTANTS.DATE_FORMATTER[formattype]
    if (formatter) commit('SET_APP_FORMATTER', formatter)
  },
  changelogs({ commit, state }) {
    const clog = state.language === 'de' ? changelog : changelogEN
    if (!clog || !clog.logs) return
    commit('SET_CHANGE_LOG', clog.logs)
  },
  messages({ commit }) {
    // commit('SET_MESSAGES', messages.messages)
  },
  addmessage({ commit }, message) {
    message.id = message.id || _.uniqueId(`msg-${_.now()}-`)
    commit('ADD_MESSAGE', message)
  },
  REMOVE_MESSAGE({ commit, state }, {id} = {}) {
    const messages = state.messages.filter(message => message.id !== id)
    commit('SET_MESSAGES', messages)
  },
  markasread({ state, commit }) {
    const readed = state.messages.map((m) => {
      return { readed: true, ...m }
    })
    commit('SET_MESSAGES', readed)
  },
  tour({ commit }) {
    // console.log('tour.steps', tour)
    // commit('SET_TOUR_STEPS', tour.steps)
  }
}

export const getters = {
  devMode(state) {
    return state.dev
  },
  experimentalMode(state) {
    return state.experimental
  },
  breakpoint(state) {
    return state.breakpoint
  },
  theme(state) {
    return state.theme
  },
  language(state) {
    return state.language
  },
  dense(state) {
    return state.dense
  },
  formatter(state) {
    return state.formatter
  },
  tableConfig(state) {
    return state.tableConfig
  },
  logs(state) {
    return state.logs
  },
  changelogs(state) {
    return state.changelogs
  },
  tour(state) {
    return state.tour
  },
  messages(state) {
    return state.messages.filter((m) => !m.readed)
  },
  messagesCount(state) {
    return state.messages.filter((m) => !m.readed).length
  },
  dialogMaxWidth(state) {
    switch(state.breakpoint.name) {
      case 'xs': return '98%'
      case 'sm': return '80%'
      case 'lg': return '40%'
      case 'xl': return '40%'
      default: return '60%'
    }
  },
  visibility(state) {
    return state.visibility
  }
}
